import React, { useState } from "react";
import ToggleSwitch from "../../../../../components/ToggleSwitch";

export default function SocialActions({ socialActions, onToggle, onChange }) {

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">

      <h3 className="font-bold text-theme_clr1 text-lg mb-4">
        Social Actions
      </h3>

      <p className="text-sm text-theme_clr2 font-semibold mb-6">
        Enable social links so fans can connect with you across platforms.
      </p>

      <div className="space-y-4">

        {socialActions.map((action, index) => (

          <div key={index} className="border rounded-lg p-4">

            {/* HEADER ROW */}

            <div className="flex items-center justify-between">

              <div className="flex items-center gap-3">

                <img
                  src={action.icon}
                  className="w-8 h-8"
                />

                <span className="font-semibold text-theme_clr1">
                  {action.name}
                </span>

              </div>
              <ToggleSwitch
                enabled={action.enabled}
                setEnabled={(val) => onToggle(index, val)}
                size="md"
                onColor="bg-theme_clr2"
              />

            </div>


            {/* INPUTS */}

            {action.enabled && (

              <div className="grid grid-cols-2 gap-4 mt-4">

                {/* ACTION BUTTON TEXT */}

                <div>
                  <label className="text-sm font-semibold text-theme_clr1">
                    Action Button Text
                  </label>

                  <input
                    type="text"
                    value={action.actionName}
                    onChange={(e) =>
                      onChange(index, "actionName", e.target.value)
                    }
                    placeholder="Follow"
                    className="w-full mt-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-theme_clr2 outline-none"
                  />
                </div>

                {/* URL */}

                <div>
                  <label className="text-sm font-semibold text-theme_clr1">
                    URL
                  </label>

                  <input
                    type="text"
                    value={action.url}
                    onChange={(e) =>
                      onChange(index, "url", e.target.value)
                    }
                    placeholder="https://..."
                    className="w-full mt-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-theme_clr2 outline-none"
                  />
                </div>

              </div>

            )}

          </div>

        ))}

      </div>

    </div>
  );
}